import { makeStyles, Theme } from "@material-ui/core";

interface CardPropagandaStylesProps {
    ativo: boolean;
}

export const useStyles = makeStyles<Theme, CardPropagandaStylesProps>((theme) => ({
    gridContainer: {
        '& p': {
            fontSize: 12
        }
    },
    status: {
        backgroundColor: ({ativo}) => ativo ? theme.palette.success.main : theme.palette.error.main,
        width: '5px',
        borderRadius: '5px',
        alignSelf: 'stretch',
        margin: '7px'
    }
}))